/** @type {import('./global')} */
import React, { createContext, useState } from "react";

/**
 * @type {React.Context<BudgetType>}
 */
/**
 * @typedef Reporting_ContextType
 * @property {string[]} selectedRadiobutton
 * @property {React.Dispatch<React.SetStateAction<string>>} setSelectedRadiobutton
 * @property {string[]} SelectedEmail
 * @property {React.Dispatch<React.SetStateAction<string>>} setSelectedEmail
 * @property {string[]} SelectedTab
 * @property {React.Dispatch<React.SetStateAction<string>>} setSelectedTab
 */

export const ReportingContext = createContext();

/**
 * @returns {Reporting_ContextType}
 */
export const useReportingContext = () => {
  const [selectedRadiobutton, setSelectedRadiobutton] = useState("csv");
  const [selectedTagValues, setSelectedTagValues] = useState([]);
  const [selectedValues, setSelectedValues] = useState([]);
  const [tempSelectTagValues, setTempSelectTagValues] = useState([]);
  const [selectGroupBy, setSelectGroupBy] = useState([]);

  /** @type {UseState<string[]>} */
  const [SelectedTab, setSelectedTab] = useState("Reporting Center");

  /** @type {UseState<string[]>} */
  const [SelectedEmail, setSelectedEmail] = useState([]);

  /** @type {UseState<string[]>} */
  const [SelectedPeriod, setSelectedPeriod] = useState("");

  /** @type {UseState<string[]>} */
  const [SelectedFrequency, setSelectedFrequency] = useState("");

  /** @type {UseState<string[]>} */
  const [selectedCreateGroupBy, setSelectedCreateGroupBy] = useState("");

  /** @type {UseState<string[]>} */
  const [SelectedPeriodFilter, setSelectedPeriodFilter] = useState([]);

  /** @type {UseState<string[]>} */
  const [SelectedFrequencyFilter, setSelectedFrequencyFilter] = useState([]);

  const [reportingTotalCount, setReportingTotalCount] = useState(0);

  const [downloadId, setDownloadId] = useState();

  const [SelectReportID, setSelectReportID] = useState("");
  const [isLayoverOpen, setIsLayoverOpen] = useState(false);
  const [EditdataId, setEditdataId] = useState();
  const [refetchTable, setRefetchTable] = useState(() => () => {});
  const [confirmationmodal, setConfirmationmodal] = useState(false);
  const [DeleteData, setDeleteData] = useState();
  const [selectTagKeys, setSelectTagKeys] = useState([]);
  return {
    selectedRadiobutton,
    setSelectedRadiobutton,
    selectedTagValues,
    setSelectedTagValues,
    selectedValues,
    setSelectedValues,
    tempSelectTagValues,
    setTempSelectTagValues,
    selectGroupBy,
    setSelectGroupBy,
    SelectedEmail,
    setSelectedEmail,
    SelectedTab,
    setSelectedTab,
    SelectedPeriod,
    setSelectedPeriod,
    SelectedFrequency,
    setSelectedFrequency,
    selectedCreateGroupBy,
    setSelectedCreateGroupBy,
    SelectReportID,
    setSelectReportID,
    SelectedPeriodFilter,
    setSelectedPeriodFilter,
    SelectedFrequencyFilter,
    setSelectedFrequencyFilter,
    reportingTotalCount,
    setReportingTotalCount,
    downloadId,
    setDownloadId,

    EditdataId,
    setEditdataId,
    isLayoverOpen,
    setIsLayoverOpen,
    confirmationmodal,
    setConfirmationmodal,
    selectTagKeys,
    setSelectTagKeys,
    DeleteData,
    setDeleteData,
    refetchTable,
    setRefetchTable,
  };
};

export const ReportingProvider = ({ children }) => {
  const context = useReportingContext();

  return (
    <>
      <ReportingContext.Provider value={context}>
        {children}
      </ReportingContext.Provider>
    </>
  );
};
